export enum BaseCustomerEmployeesFiltersEnum {
  status = 'status',
  mainQualification = 'mainQualification',
  openContract = 'openContract',
  fromDate = 'fromDate',
  pspBranch = 'pspBranch',
  department = 'department',
  location = 'location',
  search = 'search',
}
